import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getReceivedVouchersAction,
  clearReceivedVouchersAction,
} from "redux/actions/receivedVouchersAction";
import { getRangoMes } from "../utils/fechas";

const API_BASE = "/comprobantes/recibidos/busqueda/";
const DEFAULT_PAGE_SIZE = 15;
const DEFAULT_SORT = "idAsignacionComprobanteElectronico,desc";

/**
 * Hook para la vista de Gastos (comprobantes recibidos).
 *
 * @param {Object} options
 * @param {string|null} options.voucherType  codigoComprobante ("01", "04", etc.)
 *                                           null = sin filtro de tipo
 */
const usePagosCobros = ({ voucherType = null } = {}) => {
  const dispatch = useDispatch();
  const tokenUser = useSelector((state) => state.user.tk);
  const receivedVouchers = useSelector((state) => state.receivedVouchers);

  const today = new Date();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_PAGE_SIZE);
  const [mes, setMes] = useState(today.getMonth() + 1);
  const [anio, setAnio] = useState(today.getFullYear());

  /* Reset de página cuando cambia el tipo de comprobante */
  useEffect(() => {
    setPage(0);
  }, [voucherType]);

  const fetchVouchers = useCallback(() => {
    if (!tokenUser) return;

    const { ini, fin } = getRangoMes(anio, mes);

    dispatch(
      getReceivedVouchersAction({
        rucEmpresa: tokenUser,
        page,
        elementos: rowsPerPage,
        sort: DEFAULT_SORT,
        type: voucherType,
        ini,
        fin,
      }),
    );
  }, [dispatch, tokenUser, page, rowsPerPage, voucherType, anio, mes]);

  useEffect(() => {
    fetchVouchers();
  }, [fetchVouchers]);

  /* Limpia el estado al desmontar la vista */
  useEffect(() => {
    return () => {
      dispatch(clearReceivedVouchersAction());
    };
  }, [dispatch]);

  const handlePageChange = (_event, newPage) => setPage(newPage);
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleMesChange = useCallback((value) => {
    setMes(value);
    setPage(0);
  }, []);
  const handleAnioChange = useCallback((value) => {
    setAnio(value);
    setPage(0);
  }, []);

  return {
    receivedVouchers,
    page,
    rowsPerPage,
    onPageChange: handlePageChange,
    onRowsPerPageChange: handleRowsPerPageChange,
    reload: fetchVouchers,
    mes,
    anio,
    onMesChange: handleMesChange,
    onAnioChange: handleAnioChange,
  };
};

export default usePagosCobros;
